import { jsxs as _jsxs } from "react/jsx-runtime";
import { AwardIcon } from '@gemini/icons';
import { Tag } from '@gemini/ui';
const Seniority = ({ startYear, t, variant = 'light' }) => {
    return (_jsxs(Tag, { icon: AwardIcon, variant: variant, children: [t('wlac_agency_seniority'), " ", startYear] }));
};
export default Seniority;
